const dev = {
  apiGateway: {
    REGION: "us-east-2",
    URL: "https://npzdz03plb.execute-api.us-east-2.amazonaws.com/dev"
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_sr8Dwoi7S",
    APP_CLIENT_ID: "630uahttba9sefaosiqs7mg9t0",
    IDENTITY_POOL_ID: "us-east-2:7a53669a-a859-454f-beb7-a20870aa46c7"
  }
};

const prod = {
  apiGateway: {
    REGION: "us-east-2",
    URL: "https://npzdz03plb.execute-api.us-east-2.amazonaws.com/dev"
  },
  cognito: {
    REGION: "us-east-2",
    USER_POOL_ID: "us-east-2_sr8Dwoi7S",
    APP_CLIENT_ID: "630uahttba9sefaosiqs7mg9t0",
    IDENTITY_POOL_ID: "us-east-2:7a53669a-a859-454f-beb7-a20870aa46c7"
  }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

export default {
  ...config
};